const styles = () => ({
	header: {
		display: 'flex',
		flexFlow: 'row nowrap',
		justifyContent: 'center',

		height: '230px',
		backgroundColor: '#1B3E6F',
		backgroundImage: 'url(/assets/particles.svg)',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'bottom left',
		backgroundPositionX: 'left',
		backgroundPositionY: 'bottom',
		color: 'white',
		boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
		'& img': {
			display: 'block',
			height: '40px',
			marginTop: '80px',

			lineHeight: '24px',
			fontSize: 18
		}
	},
	overlay: {
		display: 'flex',
		flexFlow: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 184px)',
		position: 'absolute',
		left: '5%',
		top: '184px',
		width: '90%'
	},
	content: {
		flex: '2 1 auto',
		display: 'flex',
		flexFlow: 'column',
		justifyContent: 'space-around',
		alignItems: 'center',
		maxHeight: 'calc(100% - 108px)'
	},
	message: {
		margin: '0 auto',
		padding: '20px',
		fontSize: '20px',
		lineHeight: '24px',
		color: '#333333'
	},
	button: {
		width: '240px',
		height: '60px',
		margin: '24px auto',
		fontWeight: 'bold',
		lineHeight: '24px',
		fontSize: '18px'
	},
	footer: {
		flex: '1 1 auto',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
		'& p:nth-of-type(1)': {
			marginBottom: 0
		},
		'& p:nth-of-type(2)': {
			marginTop: '8px',
			marginBottom: '8px'
		}
	},
	'@media (max-height: 512px)': {
		overlay: {
			top: '144px',
			height: '344px'
		},
		button: {
			margin: '1em auto 20px'
		}
	},
	'@media (min-width: 480px) and (max-width: 1020px)': {
		header: {
			backgroundSize: '80% 60%'
		}
	},
	'@media (min-width: 480px) and (max-width: 760px) and (-webkit-min-device-pixel-ratio: 0)': { // hook a chrome
		header: {
			backgroundPositionX: '-80%'
		}
	},
	'@media (min-width: 760px) and (max-width: 1360px) and (-webkit-min-device-pixel-ratio: 0)': { // hook a chrome
		header: {
			backgroundPositionX: '-25%'
		}
	},
	'@media (min-width: 768px) and (max-width: 1360px)': {
		header: {
			backgroundSize: '50% 60%'
		}
	},
	'@media (min-width: 1360px)': {
		header: {
			backgroundSize: 'contain'
		}
	},
	'@media (min-width: 1020px)': {
		header: {
			'& img': {
				width: '384px',
				height: '64px',
				marginTop: '54px'
			}
		},
		overlay: {
			left: 'calc((100% - 768px)/2)!important',
			maxWidth: '768px'
		},
		message: {
			maxWidth: '640px'
		},
		footer: {
			display: 'flex',
			flexFlow: 'row',
			width: '100%',
			justifyContent: 'space-between',
			alignItems: 'flex-end',
			'& p:nth-of-type(1)': {
				marginBottom: '16px',
				textAlign: 'left'
			},
			'& p:nth-of-type(2)': {
				marginBottom: '16px',
				textAlign: 'right',
				'& br': {
					display: 'none'
				}
			}
		}
	}
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/components/main/welcome/styles.js